import React, { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import { useOkta } from '../../hooks/oktaHook';
import MainComponent from './MainComponent';
import LoginHeader from './LoginHeader';
import NavBar from './NavBar';
import Header from './Header';
import AppPages from './AppPages';
import { setBusinessUnit } from '../../redux/HomePage/cyclesByBuSlice';
import { fetchLastLoginDetails } from '../../pages/HomePage/service';
import { setIsExistingUserRx } from '../../redux/General/generalSlice';
import { useNavigate } from 'react-router';
import { getUrlWithParams } from '../../utils/Utils';
import { FullStory } from '@fullstory/browser';

const Layout = () => {
  const { authState, userDetails } = useOkta();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const selectedBu = useSelector((state) => state?.cycle?.selectedBu);
  const local_bu_name = localStorage.getItem('bu_name');
  const isExistingUser = useSelector((state) => state?.general?.isExistingUser);
  const newParams = new URLSearchParams(search);
  const selectedCycleId = Number(newParams?.get('cycleId'));
  const selectedCycle = newParams?.get('cycleName');
  const bu = newParams?.get('bu');
  const checkIfUserAlreadyinTeams = useCallback(
    async (email) => {
      const payload = {
        listOfAssignedBUs: userDetails?.BUs ?? [],
        userRole: userDetails?.roles?.[0]
      };
      try {
        const response = await fetchLastLoginDetails(email, payload);
        if (!response) {
          dispatch(setIsExistingUserRx(false));
          navigate(getUrlWithParams('/setup-team', bu, selectedCycle, selectedCycleId));
        } else {
          dispatch(setIsExistingUserRx(true));
        }
      } catch (error) {
        console.error('Error fetching team members:', error);
      }
    },
    [userDetails?.email]
  );

  /* The `useEffect` hook in the provided code snippet is responsible for setting the default business
  unit based on certain conditions. Here's a breakdown of what it does: */
  useEffect(() => {
    if (userDetails?.BUs && userDetails.BUs.length > 0) {
      let defaultBu;
      if (bu) {
        defaultBu = bu;
      } else if (local_bu_name && local_bu_name !== undefined && local_bu_name !== 'undefined') {
        defaultBu = local_bu_name;
      } else if (selectedBu !== undefined || defaultBu !== '') {
        defaultBu = selectedBu;
      } else {
        defaultBu = userDetails.BUs[0];
      }
      dispatch(setBusinessUnit(defaultBu));
    }
  }, [userDetails, selectedBu, dispatch, local_bu_name]);

  /* This `useEffect` hook is responsible for calling the `checkIfUserAlreadyinTeams` function when the
  `userDetails.email` value changes. */
  useEffect(() => {
    if (userDetails && userDetails?.email) {
      checkIfUserAlreadyinTeams(userDetails?.email);

      // initialize FullStory
      FullStory('setIdentity', {
        uid: userDetails?.gpid?.toString(),
        properties: {
          displayName: userDetails?.username,
          email: userDetails?.email
        }
      });

      // set user properties
      FullStory('setProperties', {
        type: 'user',
        properties: {
          displayName: userDetails?.username,
          email: userDetails?.email,
          buName: userDetails?.BUs.join(','),
          userType: userDetails?.roles.join(',')
        }
      });
    }
  }, [userDetails?.email]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          width: '100%',
          backgroundColor: '#F3F7FD'
        }}>
        {authState?.isAuthenticated === true ? (
          <>
            <Header />
            {isExistingUser && (
              <NavBar
                pages={
                  selectedCycleId === 0 || selectedCycleId === null
                    ? AppPages?.slice(0, 2)
                    : AppPages
                }
              />
            )}
          </>
        ) : (
          <>
            <LoginHeader />
          </>
        )}

        <MainComponent />
      </Box>
    </>
  );
};
export default Layout;
